/** Map DB rows to the Mongo-shaped objects the UI expects (_id, camelCase). */

export function mapSub(sub) {
  if (!sub) return sub
  const id = sub.id || sub._id
  return { ...sub, id, _id: id }
}

export function mapMember(row) {
  if (!row) return row
  return {
    _id: row.id || row._id,
    id: row.id || row._id,
    name: row.name,
    role: row.role,
    isActive: row.is_active ?? row.isActive ?? true,
    createdAt: row.created_at || row.createdAt,
    lastLogin: row.last_login || row.lastLogin,
    decryptedPassword: row.decryptedPassword,
    encryptedPassword: row.encryptedPassword,
    password: row.password,
  }
}

export function mapExercise(row) {
  if (!row) return row
  const id = row.id || row._id
  const subs = (row.subs || []).map(mapSub)
  return {
    _id: id,
    id,
    name: row.name,
    mode: row.mode,
    unit: row.unit,
    cardioMetric: row.cardio_metric ?? row.cardioMetric,
    desc: row.description ?? row.desc,
    subs,
    showInKiosk: row.show_in_kiosk ?? row.showInKiosk ?? true,
    isActive: row.is_active ?? row.isActive ?? true,
    createdAt: row.created_at || row.createdAt,
  }
}

export function mapSettings(row) {
  if (!row) return row
  return {
    _id: row.id,
    id: row.id,
    kioskShowList: row.kiosk_show_list ?? row.kioskShowList,
    theme: row.theme,
    kioskBgs: row.kiosk_bgs ?? row.kioskBgs,
    updatedAt: row.updated_at || row.updatedAt,
  }
}

export function mapResult(row) {
  if (!row) return row
  const id = row.id || row._id
  const member = row.member || row.members || row.memberId
  const exercise = row.exercise || row.exercises || row.exerciseId

  let memberId = row.member_id
  if (member && typeof member === 'object') {
    memberId = {
      _id: member.id || member._id,
      id: member.id || member._id,
      name: member.name,
    }
  } else if (typeof row.memberId === 'object') {
    memberId = row.memberId
  }

  let exerciseId = row.exercise_id
  if (exercise && typeof exercise === 'object') {
    exerciseId = {
      _id: exercise.id || exercise._id,
      id: exercise.id || exercise._id,
      name: exercise.name,
      mode: exercise.mode,
      unit: exercise.unit,
      cardioMetric: exercise.cardio_metric ?? exercise.cardioMetric,
      subs: (exercise.subs || []).map(mapSub),
    }
  } else if (typeof row.exerciseId === 'object') {
    exerciseId = row.exerciseId
  }

  return {
    _id: id,
    id,
    memberId,
    exerciseId,
    subId: row.sub_id ?? row.subId,
    payload: row.payload,
    createdAt: row.created_at || row.createdAt,
  }
}

export function exerciseToDb(data) {
  const out = {}
  if (data.name !== undefined) out.name = data.name
  if (data.mode !== undefined) out.mode = data.mode
  if (data.unit !== undefined) out.unit = data.unit
  if (data.cardioMetric !== undefined) out.cardio_metric = data.cardioMetric
  if (data.desc !== undefined) out.description = data.desc
  if (data.subs !== undefined) {
    out.subs = (data.subs || []).map((s) => {
      const id = s.id || s._id || crypto.randomUUID()
      const { _id, ...rest } = s
      return { ...rest, id }
    })
  }
  if (data.showInKiosk !== undefined) out.show_in_kiosk = data.showInKiosk
  return out
}
